import { all } from 'redux-saga/effects';
import getDeliveryInfoServiceWorker from './DeliveryInfoSaga';

export default function* rootSaga(action) {
	yield all([getDeliveryInfoServiceWorker(action)]);
}
